import React, { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/AuthStore";
import { useSchoolStore } from "../../../store/SchoolStore";
import SchoolHat from "../../../assets/school_hat.png";
import { getStats } from "../../../apis/Utilities";

const Stats = () => {

  const [state, actions] = useAuthStore();
  const [{ schoolId },] = useSchoolStore();
  const [categoryCount, setCategoryCount] = useState(0);
  const [newCategoryCount, setNewCategoryCount] = useState(0);
  const [instructorCount, setInstructorCount] = useState(0);
  const [newInstructorCount, setNewInstructorCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [newStudentCount, setNewStudentCount] = useState(0);
  const [notification, setNotification] = useState(0);
  const [newNotification, setNewNotification] = useState(0);

  async function fetchStatsData() {
    var res = await getStats(schoolId);
    setCategoryCount(res.data.category);
    setStudentCount(res.data.student);
    setInstructorCount(res.data.instructors);
    setNotification(res.data.notification);
  };

  useEffect(() => {

    fetchStatsData();
    const interval = setInterval(() => {
      fetchStatsData();
    }, 5000)

    return () => clearInterval(interval);

  }, [schoolId, categoryCount, instructorCount, studentCount, notification])

  return (
    <div className="grid">
      <div className="col-12 md:col-6 lg:col-3">
        <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round">
          <div className="flex justify-content-between mb-3">
            <div>
              <span className="block text-500 font-medium mb-3">Category</span>
              <div className="text-900 font-medium text-xl">{categoryCount}</div>
            </div>
            <div
              className="flex align-items-center justify-content-center bg-blue-100 border-round"
              style={{ width: "2.5rem", height: "2.5rem" }}
            >
              <i className="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <span className="text-green-500 font-medium">{newCategoryCount} new </span>
          <span className="text-500">since last visit</span>
        </div>
      </div>
      <div className="col-12 md:col-6 lg:col-3">
        <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round">
          <div className="flex justify-content-between mb-3">
            <div>
              <span className="block text-500 font-medium mb-3">Instructors</span>
              <div className="text-900 font-medium text-xl">{instructorCount}</div>
            </div>
            <div
              className="flex align-items-center justify-content-center bg-orange-100 border-round"
              style={{ width: "2.5rem", height: "2.5rem" }}
            >
              <img className="text-orange-500 text-xl" src={SchoolHat} alt="school-hat" height={30} />
            </div>
          </div>
          <span className="text-green-500 font-medium">{newInstructorCount}+ </span>
          <span className="text-500">since last week</span>
        </div>
      </div>
      <div className="col-12 md:col-6 lg:col-3">
        <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round">
          <div className="flex justify-content-between mb-3">
            <div>
              <span className="block text-500 font-medium mb-3">Students</span>
              <div className="text-900 font-medium text-xl">{studentCount}</div>
            </div>
            <div
              className="flex align-items-center justify-content-center bg-cyan-100 border-round"
              style={{ width: "2.5rem", height: "2.5rem" }}
            >
              <i className="pi pi-users text-cyan-500 text-xl"></i>
            </div>
          </div>
          <span className="text-green-500 font-medium">{newStudentCount} </span>
          <span className="text-500">newly registered</span>
        </div>
      </div>
      <div className="col-12 md:col-6 lg:col-3">
        <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round">
          <div className="flex justify-content-between mb-3">
            <div>
              <span className="block text-500 font-medium mb-3">Notifications</span>
              <div className="text-900 font-medium text-xl">{newNotification} Unread</div>
            </div>
            <div
              className="flex align-items-center justify-content-center bg-purple-100 border-round"
              style={{ width: "2.5rem", height: "2.5rem" }}
            >
              <i className="pi pi-bell text-purple-500 text-xl"></i>
            </div>
          </div>
          <span className="text-green-500 font-medium">{notification} </span>
          <span className="text-500">responded</span>
        </div>
      </div>
    </div>
  );
};

export default Stats;
